
export const notificationSwal = {
    success:"บันทึกข้อมูลเรียบร้อย",
    error:"เกิดข้อผิดพลาดในการบันทึกข้อมูล",
    password_not_match:"รหัสผ่านไม่ตรงกัน"
}